// Application Configuration with Light Theme
const CONFIG = {
  mapCenter: [11.5, 78.5],
  mapZoom: 7,
  searchPlaceholder: "Search by city, pincode, or store name...",
  noResultsMessage: "No locations found matching your criteria.",
  storeMarkerColor: "#ffba20",
  distributorMarkerColor: "#C5172E",
  theme: "light",
};

// Location Data
const locations = [
  {
    name: "IBX Theni",
    address:
      "Eswar Plaza, 14, Cumbum Rd, near Krishna Theatre, RMTC Colony, Theni, Tamil Nadu 625531",
    contactNo: "+91 8825948907",
    times: "10:00 AM - 9:30 PM",
    gstn: "GSTIN: 33AAICI1123R1ZG",
    category: "Store",
    coordinates: [10.00702590065742, 77.47244731148712],
  },
  {
    name: "Athikalathu Alangara Maligai",
    address:
      "9RPC+5C5, 867/2, N Main St, Melaraja Vidi, Brindavan, Pudukkottai, Tamil Nadu 622001",
    contactNo: "8220082202",
    times: "9:00 AM - 9:00 PM",
    category: "Distributor",
    coordinates: [10.385955908797598, 78.81941890387095],
  },
  {
    name: "Malar Family Store",
    address:
      "old no 108, new, no 206, Gollavar Agraharam Rd, opp. kcs school, Washermanpet, Chennai, Tamil Nadu 600021",
    times: "9:30 AM - 11:00 PM",
    category: "Distributor",
    coordinates: [13.116109798727475, 80.28779724129873],
  },
  {
    name: "The Chennai Silks - T.Nagar",
    address:
      "55, N Usman Rd, near Fathima Jewellers, T. Nagar, Chennai, Tamil Nadu 600017",
    contactNo: "044 2431 0888",
    times: "9:30 AM - 09:30 PM",
    category: "Distributor",
    coordinates: [13.039219560482085, 80.23093207890956],
  },
  {
    name: "The Chennai Silks - Thiruvallur",
    address:
      "No.65A, C.V Naidu Road Meera Theatre, opposite Thiruvallur, Tamil Nadu 602001",
    contactNo: "7338758706",
    times: "9:30 AM - 09:30 PM",
    category: "Distributor",
    coordinates: [13.143396535185477, 79.89635967565599],
  },
];

// Global Variables
let map;
let markers = [];
let currentFilter = "All";
let currentSearchTerm = "";
let filteredLocations = [...locations];
let activeLocationIndex = null;

// DOM Elements - will be initialized after DOM loads
let elements = {};

// Utility Functions
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function sanitizeForSearch(text) {
  if (!text) return "";
  return text
    .toLowerCase()
    .replace(/[^\w\s]/gi, " ")
    .trim();
}

function extractSearchTerms(location) {
  const terms = [location.name, location.address, location.category];

  if (location.contactNo) terms.push(location.contactNo);

  // Extract city and pincode from address
  const addressParts = location.address.split(",");
  addressParts.forEach((part) => {
    const trimmed = part.trim();
    // Check if it's a pincode (6 digits)
    if (/^\d{6}$/.test(trimmed)) {
      terms.push(trimmed);
    }
    terms.push(trimmed);
  });

  return terms.map(sanitizeForSearch).join(" ");
}

// Map Functions
function initializeMap() {
  try {
    console.log(L);
    map = L.map("sl-map", {
      zoomControl: true,
      scrollWheelZoom: true,
    }).setView(CONFIG.mapCenter, CONFIG.mapZoom);

    // Use a clean, light map style
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution: "© OpenStreetMap contributors",
    }).addTo(map);

    // Hide loading overlay
    setTimeout(() => {
      if (elements.mapLoading) {
        elements.mapLoading.style.display = "none";
      }
    }, 1000);

    updateMapMarkers();
  } catch (error) {
    console.error("Error initializing map:", error);
    if (elements.mapLoading) {
      elements.mapLoading.innerHTML =
        '<p style="color: #E53E3E;">Error loading map</p>';
    }
  }
}

function createCustomMarker(location, index) {
  const color =
    location.category === "Store"
      ? CONFIG.storeMarkerColor
      : CONFIG.distributorMarkerColor;
  const icon = location.category === "Store" ? "🏪" : "🚚";

  const markerHtml = `
    <div class="custom-marker-wrapper" style="
      background-color: ${color};
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: 2px solid white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.2);
      cursor: pointer;
      transition: transform 0.2s ease;
    ">
      ${icon}
    </div>
  `;

  const marker = L.marker(location.coordinates, {
    icon: L.divIcon({
      html: markerHtml,
      iconSize: [36, 36],
      iconAnchor: [18, 18],
      popupAnchor: [0, -18],
      className: "custom-div-icon",
    }),
  });

  // Create clean popup with light theme styling
  const popupContent = document.createElement("div");
  popupContent.style.cssText =
    'text-align: center; min-width: 200px; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;';
  popupContent.innerHTML = `
    <h4 style="margin: 0 0 8px 0; color: ${color}; font-size: 16px; font-weight: 600;">${
    location.name
  }</h4>
    <p style="margin: 0 0 8px 0; font-size: 13px; color: #718096; line-height: 1.4;">${
      location.address
    }</p>
    ${
      location.contactNo
        ? `<p style="margin: 0 0 12px 0; font-size: 13px; color: #2D3748; font-weight: 500;">📞 ${location.contactNo}</p>`
        : ""
    }
    <div style="display: flex; gap: 6px; margin-top: 12px;">
      <button class="popup-details-btn" data-index="${index}" style="
        flex: 1; padding: 8px 12px; background: ${color}; color: white; 
        border: none; border-radius: 6px; font-size: 12px; cursor: pointer;
        font-weight: 500; transition: all 0.2s ease;
      ">Details</button>
      <button class="popup-directions-btn" data-address="${encodeURIComponent(
        location.address
      )}" style="
        flex: 1; padding: 8px 12px; background: #38A169; color: white; 
        border: none; border-radius: 6px; font-size: 12px; cursor: pointer;
        font-weight: 500; transition: all 0.2s ease;
      ">Directions</button>
    </div>
  `;

  // Add hover effects to buttons
  const detailsBtn = popupContent.querySelector(".popup-details-btn");
  const directionsBtn = popupContent.querySelector(".popup-directions-btn");

  detailsBtn.addEventListener("mouseenter", () => {
    detailsBtn.style.opacity = "0.9";
  });
  detailsBtn.addEventListener("mouseleave", () => {
    detailsBtn.style.opacity = "1";
  });

  directionsBtn.addEventListener("mouseenter", () => {
    directionsBtn.style.opacity = "0.9";
  });
  directionsBtn.addEventListener("mouseleave", () => {
    directionsBtn.style.opacity = "1";
  });

  // Add event listeners to popup buttons
  detailsBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    const idx = parseInt(e.target.dataset.index);
    showStoreDetails(idx);
  });

  directionsBtn.addEventListener("click", (e) => {
    e.stopPropagation();
    const address = decodeURIComponent(e.target.dataset.address);
    getDirections(address);
  });

  marker.bindPopup(popupContent);

  marker.on("click", () => {
    highlightLocation(index);
    scrollToLocation(index);
  });

  return marker;
}

function updateMapMarkers() {
  if (!map) return;

  // Clear existing markers
  markers.forEach((marker) => {
    map.removeLayer(marker);
  });
  markers = [];

  // Add markers for filtered locations
  filteredLocations.forEach((location) => {
    const originalIndex = locations.indexOf(location);
    const marker = createCustomMarker(location, originalIndex);
    markers.push(marker);
    marker.addTo(map);
  });

  // Adjust map view to show all markers
  if (markers.length > 0) {
    const group = new L.featureGroup(markers);
    const bounds = group.getBounds();
    if (bounds.isValid()) {
      map.fitBounds(bounds, { padding: [20, 20] });
    }
  } else {
    map.setView(CONFIG.mapCenter, CONFIG.mapZoom);
  }
}

// Filter Functions
function applyFilters() {
  let filtered = [...locations];

  // Apply category filter
  if (currentFilter !== "All") {
    filtered = filtered.filter(
      (location) => location.category === currentFilter
    );
  }

  // Apply search filter
  if (currentSearchTerm) {
    const searchTermLower = sanitizeForSearch(currentSearchTerm);
    filtered = filtered.filter((location) => {
      const searchableText = extractSearchTerms(location);
      return searchableText.includes(searchTermLower);
    });
  }

  filteredLocations = filtered;
  updateLocationsList();
  updateMapMarkers();
  updateResultsCount();
}

function updateResultsCount() {
  const count = filteredLocations.length;
  let text = `${count} location${count !== 1 ? "s" : ""}`;

  if (currentFilter !== "All") {
    text += ` (${currentFilter})`;
  }

  if (currentSearchTerm) {
    text += ` matching "${currentSearchTerm}"`;
  }

  if (elements.resultsCount) {
    elements.resultsCount.textContent = text;
  }
}

// Location List Functions
function createLocationItem(location, index) {
  const item = document.createElement("div");
  item.className = "sl-location";
  item.setAttribute("role", "button");
  item.setAttribute("tabindex", "0");
  item.dataset.locationIndex = index;

  const categoryIcon =
    location.category === "Store" ? "fas fa-store" : "fas fa-truck";
  const categoryColor =
    location.category === "Store"
      ? CONFIG.storeMarkerColor
      : CONFIG.distributorMarkerColor;

  item.innerHTML = `
    <div class="sl-location__header">
      <h6 class="sl-location__name">${location.name}</h6>
      <i class="${categoryIcon} sl-location__category-icon" style="color: ${categoryColor};"></i>
    </div>
    <p class="sl-location__info">${location.address}</p>
    ${
      location.contactNo
        ? `<p class="sl-location__info">📞 ${location.contactNo}</p>`
        : ""
    }
    ${
      location.times
        ? `<p class="sl-location__info">🕒 ${location.times}</p>`
        : ""
    }
    <div class="sl-location__actions">
      <button class="sl-location-btn sl-directions-btn" data-address="${encodeURIComponent(
        location.address
      )}">
        <i class="fas fa-directions"></i>
        Directions
      </button>
      <button class="sl-location-btn sl-location-btn--secondary sl-details-btn" data-index="${index}">
        <i class="fas fa-info-circle"></i>
        Details
      </button>
    </div>
  `;

  // Add event listeners for action buttons
  const directionsBtn = item.querySelector(".sl-directions-btn");
  const detailsBtn = item.querySelector(".sl-details-btn");

  if (directionsBtn) {
    directionsBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      const address = decodeURIComponent(
        e.target.closest(".sl-directions-btn").dataset.address
      );
      getDirections(address);
    });
  }

  if (detailsBtn) {
    detailsBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      const idx = parseInt(e.target.closest(".sl-details-btn").dataset.index);
      showStoreDetails(idx);
    });
  }

  // Add click handler for location selection
  item.addEventListener("click", (e) => {
    // Only handle location selection if not clicking on action buttons
    if (!e.target.closest(".sl-location__actions")) {
      highlightLocation(index);
      focusOnMap(location);
    }
  });

  item.addEventListener("keydown", (e) => {
    if (
      (e.key === "Enter" || e.key === " ") &&
      !e.target.closest(".sl-location__actions")
    ) {
      e.preventDefault();
      highlightLocation(index);
      focusOnMap(location);
    }
  });

  return item;
}

function updateLocationsList() {
  if (!elements.locationsList || !elements.noResults) return;

  elements.locationsList.innerHTML = "";

  if (filteredLocations.length === 0) {
    elements.noResults.classList.add("sl-show");
    elements.locationsList.style.display = "none";
    return;
  }

  elements.noResults.classList.remove("sl-show");
  elements.locationsList.style.display = "block";

  filteredLocations.forEach((location, filteredIndex) => {
    const originalIndex = locations.indexOf(location);
    const item = createLocationItem(location, originalIndex);
    elements.locationsList.appendChild(item);

    // Animate item appearance
    setTimeout(() => {
      item.classList.add("sl-show");
    }, filteredIndex * 30);
  });
}

function highlightLocation(index) {
  // Remove active class from all locations
  const locationItems = elements.locationsList.querySelectorAll(".sl-location");
  locationItems.forEach((item) => item.classList.remove("sl-location--active"));

  // Add active class to selected location
  const targetItem = elements.locationsList.querySelector(
    `[data-location-index="${index}"]`
  );
  if (targetItem) {
    targetItem.classList.add("sl-location--active");
    activeLocationIndex = index;
  }
}

function scrollToLocation(index) {
  const targetItem = elements.locationsList.querySelector(
    `[data-location-index="${index}"]`
  );
  if (targetItem) {
    targetItem.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }
}

function focusOnMap(location) {
  if (map && location.coordinates) {
    map.setView(location.coordinates, 15);

    // Find and open the marker popup
    const marker = markers.find((m) => {
      const pos = m.getLatLng();
      return (
        Math.abs(pos.lat - location.coordinates[0]) < 0.0001 &&
        Math.abs(pos.lng - location.coordinates[1]) < 0.0001
      );
    });

    if (marker) {
      marker.openPopup();
    }
  }
}

// Modal Functions
function showStoreDetails(index) {
  const location = locations[index];
  if (!location || !elements.modal) return;

  console.log("Showing store details for:", location.name);

  // Populate modal content
  const modalStoreName = document.getElementById("sl-modal-store-name");
  const modalAddress = document.getElementById("sl-modal-address");
  const modalCategory = document.getElementById("sl-modal-category");

  if (modalStoreName) modalStoreName.textContent = location.name;
  if (modalAddress) modalAddress.textContent = location.address;
  if (modalCategory) modalCategory.textContent = location.category;

  // Optional fields
  const contactItem = document.getElementById("sl-modal-contact-item");
  const timesItem = document.getElementById("sl-modal-times-item");
  const gstnItem = document.getElementById("sl-modal-gstn-item");
  const modalContact = document.getElementById("sl-modal-contact");
  const modalTimes = document.getElementById("sl-modal-times");
  const modalGstn = document.getElementById("sl-modal-gstn");

  if (location.contactNo && modalContact && contactItem) {
    modalContact.textContent = location.contactNo;
    contactItem.classList.remove("sl-detail-item--hidden");
    contactItem.classList.add("sl-show");
  } else if (contactItem) {
    contactItem.classList.add("sl-detail-item--hidden");
    contactItem.classList.remove("sl-show");
  }

  if (location.times && modalTimes && timesItem) {
    modalTimes.textContent = location.times;
    timesItem.classList.remove("sl-detail-item--hidden");
    timesItem.classList.add("sl-show");
  } else if (timesItem) {
    timesItem.classList.add("sl-detail-item--hidden");
    timesItem.classList.remove("sl-show");
  }

  if (location.gstn && modalGstn && gstnItem) {
    modalGstn.textContent = location.gstn;
    gstnItem.classList.remove("sl-detail-item--hidden");
    gstnItem.classList.add("sl-show");
  } else if (gstnItem) {
    gstnItem.classList.add("sl-detail-item--hidden");
    gstnItem.classList.remove("sl-show");
  }

  // Set up directions button
  const directionsBtn = document.getElementById("sl-modal-directions");
  if (directionsBtn) {
    directionsBtn.onclick = () => {
      getDirections(location.address);
      hideStoreDetails();
    };
  }

  // Show modal
  elements.modal.classList.remove("sl-modal--hidden");
  document.body.style.overflow = "hidden";
}

function hideStoreDetails() {
  if (elements.modal) {
    elements.modal.classList.add("sl-modal--hidden");
  }
  document.body.style.overflow = "";
}

// Navigation Functions
function getDirections(address) {
  console.log("Getting directions for:", address);
  const encodedAddress = encodeURIComponent(address);
  const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;
  window.open(googleMapsUrl, "_blank");
}

// Search Functions
const debouncedSearch = debounce((searchTerm) => {
  console.log("Search term:", searchTerm);
  currentSearchTerm = searchTerm.trim();
  applyFilters();
}, 300);

function handleSearch(event) {
  const value = event.target.value;
  console.log("Search input:", value);
  debouncedSearch(value);

  // Show/hide clear button
  if (elements.clearSearch) {
    if (value.length > 0) {
      elements.clearSearch.classList.add("sl-visible");
    } else {
      elements.clearSearch.classList.remove("sl-visible");
    }
  }
}

function clearSearch() {
  console.log("Clearing search");
  if (elements.searchInput) {
    elements.searchInput.value = "";
  }
  if (elements.clearSearch) {
    elements.clearSearch.classList.remove("sl-visible");
  }
  currentSearchTerm = "";
  applyFilters();
  if (elements.searchInput) {
    elements.searchInput.focus();
  }
}

// Tab Functions
function handleTabClick(event) {
  const button = event.currentTarget;
  const category = button.getAttribute("data-category");
  console.log("Tab clicked:", category);

  if (!category) return;

  // Update active tab
  elements.tabButtons.forEach((btn) => btn.classList.remove("sl-tab--active"));
  button.classList.add("sl-tab--active");

  // Update filter
  currentFilter = category;
  console.log("Current filter set to:", currentFilter);
  applyFilters();
}

// Initialize DOM elements
function initializeElements() {
  elements = {
    sidebar: document.getElementById("sl-sidebar"),
    locationsList: document.getElementById("sl-locations-list"),
    mapContainer: document.getElementById("sl-map"),
    mapLoading: document.getElementById("sl-map-loading"),
    searchInput: document.getElementById("sl-search-input"),
    clearSearch: document.getElementById("sl-clear-search"),
    noResults: document.getElementById("sl-no-results"),
    resultsCount: document.getElementById("sl-results-count"),
    tabButtons: document.querySelectorAll(".sl-tab"),
    modal: document.getElementById("sl-store-modal"),
    modalBackdrop: document.getElementById("sl-modal-backdrop"),
    modalClose: document.getElementById("sl-modal-close"),
    modalCloseBtn: document.getElementById("sl-modal-close-btn"),
  };

  console.log(
    "Elements initialized:",
    Object.keys(elements).map((key) => ({
      key,
      found: !!elements[key],
      length: elements[key]?.length || "N/A",
    }))
  );
}

// Event Listeners
function setupEventListeners() {
  // Tab buttons
  if (elements.tabButtons && elements.tabButtons.length > 0) {
    elements.tabButtons.forEach((button) => {
      button.addEventListener("click", handleTabClick);
      console.log(
        "Added click listener to tab button:",
        button.getAttribute("data-category")
      );
    });
  }

  // Search input
  if (elements.searchInput) {
    elements.searchInput.addEventListener("input", handleSearch);
    console.log("Added input listener to search");
  }

  if (elements.clearSearch) {
    elements.clearSearch.addEventListener("click", clearSearch);
    console.log("Added click listener to clear search");
  }

  // Modal close handlers
  if (elements.modalClose) {
    elements.modalClose.addEventListener("click", hideStoreDetails);
  }

  if (elements.modalCloseBtn) {
    elements.modalCloseBtn.addEventListener("click", hideStoreDetails);
  }

  if (elements.modalBackdrop) {
    elements.modalBackdrop.addEventListener("click", hideStoreDetails);
  }

  // Keyboard handlers
  document.addEventListener("keydown", (e) => {
    if (
      e.key === "Escape" &&
      elements.modal &&
      !elements.modal.classList.contains("sl-modal--hidden")
    ) {
      hideStoreDetails();
    }
  });

  // Map resize handler
  window.addEventListener(
    "resize",
    debounce(() => {
      if (map) {
        map.invalidateSize();
      }
    }, 250)
  );
}

// Initialization
function initializeApp() {
  try {
    console.log("Initializing app...");
    initializeElements();
    setupEventListeners();
    updateLocationsList();
    updateResultsCount();

    // Initialize map after a short delay to ensure container is ready
    setTimeout(() => {
      initializeMap();
    }, 100);

    console.log("Store Locator initialized successfully");
    console.log("Initial state:", {
      currentFilter,
      currentSearchTerm,
      filteredLocations: filteredLocations.length,
    });
  } catch (error) {
    console.error("Error initializing app:", error);
    if (elements.resultsCount) {
      elements.resultsCount.textContent = "Error loading application";
    }
  }
}

// Make functions globally available for inline event handlers
window.showStoreDetails = showStoreDetails;
window.getDirections = getDirections;

// Start the application when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeApp);
} else {
  initializeApp();
}
